import React, { useState } from 'react'
import { COLORES } from '../../../../config/colores'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { Row, Col } from 'react-bootstrap'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'

function PlanDeEmbarqueView (props) {
  const { anuncio, handleDelete } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const onDelete = () => {
    handleClose()
    handleDelete()
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='sm'
      >
        <DialogView
          confirmCallback={onDelete}
          cancelCallback={handleClose}
          title='Eliminar plan de embarque'
          content={<DialogConfirmacionContent
            message='¿Esta seguro que desea eliminar el plan de embarque seleccionado?'
          />}
        />
      </Dialog>

      <Row className='container-data-plan-embarque'>
        <Col md={5} style={{ textAlign: 'left', padding: 0 }}>
          <h5>Buque: <strong>{anuncio.nombre}</strong></h5>
        </Col>
        <Col md={5} style={{ textAlign: 'left', padding: 0 }}>
          <h5>Agencia Maritima: <strong>{anuncio.nombreAgenciaMaritima}</strong> </h5>
        </Col>

        <Col md={2} style={{ textAlign: 'center', padding: 0 }}>
          <Button
            variant='outlined'
            style={{ color: COLORES.grey.dark, width: '100%', fontWeight: 'bold' }}
            size='small'
            onClick={handleOpen}
          >
                ELIMINAR
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default PlanDeEmbarqueView
